<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Show from "./show";
import { mapGetters } from 'vuex';

export default {
  page: {
    title: "استمارة حجز بوث",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Show},
  data() {
    return {
      title: "المسجلين في الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/"
        },
        {
          text: "استمارة حجز بوث",
          active: true,
        }
      ],
      
      canShow: false,
      loadingContent: true
    };
  },
  computed:{
    ...mapGetters('auth', ['getUser']),
  },
  created(){
    this.canShow = this.getUser.hasPermission('show_booths');
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">

          <div class="card-body">
            <Show v-if="canShow" />
          </div>

        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>